import { render, staticRenderFns } from "./teacherDashboard.vue?vue&type=template&id=3b09c0ca&scoped=true"
import script from "./teacherDashboard.vue?vue&type=script&lang=js"
export * from "./teacherDashboard.vue?vue&type=script&lang=js"
import style0 from "./teacherDashboard.vue?vue&type=style&index=0&id=3b09c0ca&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b09c0ca",
  null
  
)

export default component.exports